/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router';

import AddressFooter from '../../shared/AddressFooter';

const BarberIgAuth = (props) => {
  const { name, link } = props.location.query;
  return (
    <div>
      <Helmet>
        <title>Get your IG pics into Squire!</title>
      </Helmet>
      <div className="c-ig-auth-body">
        <div className="c-ig-squire-logo" />
        <h2 className="c-ig-title">Hi {name}, Happy new year!</h2>
        <p className="c-ig-text-body u-mb-8">
          Some of our most successful barbers have Instagram profiles and use it to showcase their craft.
        </p>
        <p className="c-ig-text-body u-mb-8">
          We’re working hard to improve the booking experience for your clients and in order
          to have your pictures show up on the website, you’ll need you to give Squire access.
        </p>
        <div className="c-ig-instruction u-mb-5">
          <div>1</div>
          <p>Click the button below to authorize Squire</p>
        </div>
        <div className="c-ig-instruction u-mb-10">
          <div>2</div>
          <p>Tag the pictures you’d like to populate on Squire app with #getsquire</p>
        </div>
        <a className="c-ig-auth-button" href={link} target="_blank" />
      </div>
      <AddressFooter />
    </div>
  );
};

BarberIgAuth.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      name: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default withRouter(BarberIgAuth);



// WEBPACK FOOTER //
// ./src/app/notifications/barber/BarberIgAuthInstructions/index.jsx